export default class BPLieferungStandortRequest {
  id: string
  liefergebietId: string
  strasse: string
  plz: string
  ort: string
}
